import { VenueStoreType } from '@/types/store/venue-store.type';

export const state: VenueStoreType = {
  venues: null,
  venue: null,
};
